import axios from "axios";
import moment from "moment";
import config from "utils/config";
import * as action from "constants/orderConstants";
import { userLogout } from "./userActions";
import redirect from "utils/redirect";
import { RentripsURL } from "utils/request";

// Dapetin semua order jalan user dari id nya
// METHOD POST
// Params: userId
export const getOngoingOrder = (userId: string) => async (dispatch: any) => {
  try {
    dispatch({});

    dispatch({});
  } catch (error: any) {
    dispatch({});
  }
};

export const getTransaction =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: action.ORDER_SINGLE_REQUEST,
      });

      const { token } = getState().userInfo.userInfo;
      const { data } = await axios.get(RentripsURL +`/api/order/${id}`, config(token));

      dispatch({ type: action.ORDER_SINGLE_SUCCESS, payload: data });
    } catch (error: any) {
      dispatch({
        type: action.ORDER_SINGLE_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      redirect(error, dispatch);
    }
  };

// Dapetin semua order masuk user dari id nya
// METHOD POST
// Params: userId
export const getInOrder = () => async (dispatch: any, getState: any) => {
  try {
    dispatch({
      type: action.ORDER_IN_GET_REQUEST,
    });
    const { token } = getState().userInfo.userInfo;
    const { data } = await axios.get(RentripsURL +"/api/order?type=in", config(token));

    dispatch({ type: action.ORDER_IN_GET_SUCCESS, payload: data });
  } catch (error: any) {
    dispatch({
      type: action.ORDER_IN_GET_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    redirect(error, dispatch);
  }
};

// Dapetin semua order keluar user
// METHOD GET
export const getOutOrder = () => async (dispatch: any, getState: any) => {
  try {
    dispatch({ type: action.ORDER_OUT_GET_REQUEST });

    const { token } = getState().userInfo.userInfo;
    const { data } = await axios.get(RentripsURL +"/api/order?type=out", config(token));

    dispatch({ type: action.ORDER_OUT_GET_SUCCESS, payload: data });
  } catch (error: any) {
    dispatch({
      type: action.ORDER_ADD_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    redirect(error, dispatch);
  }
};

// Tambahin ke order
// METHOD POST
// Params: productId, renterId, vendorId, couponId, startDate, endDate, delivery, status, price, days,
export const addOrder =
  (
    productId: string,
    startDate: moment.Moment,
    endDate: moment.Moment,
    startTime: string,
    endTime: string,
    days: number
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: action.ORDER_ADD_REQUEST,
      });

      const data = {
        productId,
        startDate,
        endDate,
        startTime,
        endTime,
        days,
      };

      dispatch({ type: action.ORDER_ADD_SUCCESS, payload: data });
      localStorage.setItem("ongoingOrder", JSON.stringify(data));
    } catch (error: any) {
      dispatch({
        type: action.ORDER_ADD_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      if (error.data && error.response.data.message === "Session Expired") {
        dispatch(userLogout());
      }
    }
  };

interface ILocation {
  name: string;
  price: number;
}
export const payOrder =
  (
    pickUp: ILocation,
    dropOff: ILocation,
    couponId: string,
    discount: number,
    delivery: string
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      const { ongoingOrder } = getState().ongoingOrder;
      const { singleProduct } = getState().productSingle;

      const { startDate, endDate, startTime, endTime, days } = ongoingOrder;

      const { token } = getState().userInfo.userInfo;

      const body = {
        productId: singleProduct._id,
        vendorId: singleProduct.profile.userId,
        couponId,
        startDate,
        endDate,
        startTime,
        endTime,
        pickUp,
        dropOff,
        delivery,
        discount,
        price: singleProduct.price,
        days,
      };

      const { data } = await axios.post(RentripsURL +"/api/order/", body, config(token));

      dispatch({ type: action.ORDER_PAY_SUCCESS, payload: data });

      localStorage.removeItem("ongoingOrder");
    } catch (error: any) {
      dispatch({
        type: action.ORDER_ADD_ERROR,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      if (error.data && error.response.data.message === "Session Expired") {
        dispatch(userLogout());
      }
    }
  };

// Update status order
// METHOD PATCH
// Params: orderId, process
export const updateOrder =
  (orderId: string, status: string) => async (dispatch: any, getState: any) => {
    try {
      const { token } = getState().userInfo.userInfo;

      let newStatus;
      switch (status) {
        case "menunggu konfirmasi":
          newStatus = "new";
          break;
        case "siap dikirim":
          newStatus = "ready";
          break;
        case "dikirim":
          newStatus = "delivered";
          break;
        case "selesai":
          newStatus = "finished";
          break;
        case "batal":
          newStatus = "canceled";
          break;
      }

      const { data } = await axios.patch(
        RentripsURL +`/api/order/${orderId}`,
        { status: newStatus },
        config(token)
      );

      dispatch({ type: action.ORDER_UPDATE_SUCCESS, payload: data });
    } catch (error: any) {
      dispatch({});
    }
  };
